/*
 * deferred-inline-scripts.js
 * --------------------------
 * vendor.js (jQuery + eklentiler), global.js ve lazysizes.min.js artik `defer` ile
 * yukleniyor; yani render'i bloklamiyorlar ama HTML ayristirilirken de hazir degiller.
 *
 * Temadaki bazi inline <script> bloklari jQuery'yi ayristirma aninda kullaniyordu.
 * O bloklarin tipi `text/x-jq` yapildi -> tarayici onlari calistirmiyor, sadece metin
 * olarak tutuyor. Bu dosya, vendor.js calistiktan hemen sonra o bloklari
 * ORIJINAL GLOBAL SCOPE'ta yeniden calistirir.
 *
 * Neden replaceChild ile yeni bir <script> olusturuyoruz:
 * eval() veya new Function() global scope'u korumaz; yeni bir script elemani
 * eklemek ise kodu tam olarak eskisi gibi, global scope'ta calistirir.
 * Boylece bloklarin icindeki `function x(){}` / `var y` tanimlari global kalir.
 *
 * Bu dosya global-script.liquid icinde vendor/global/lazysizes'tan HEMEN SONRA,
 * slider.js ve theme.js'ten ONCE `defer` ile yuklenir. defer scriptleri belge
 * sirasina gore calistigi icin orijinal calisma sirasi birebir korunur.
 */
(function () {
  'use strict';

  // Guvenlik agi: lazysizes artik `async` ile yuklenip kendini baslatiyor.
  // init() ikinci kez cagrilirsa kutuphane kendi icinde yok sayar; burada sadece
  // async script herhangi bir sebeple gec kalirsa diye duruyor.
  if (window.lazySizes && typeof window.lazySizes.init === 'function') {
    try {
      window.lazySizes.init();
    } catch (e) {}
  }

  var pending = document.querySelectorAll('script[type="text/x-jq"]');
  if (!pending.length) return;

  // querySelectorAll statik NodeList dondurur; dugumleri degistirmek listeyi bozmaz.
  for (var i = 0; i < pending.length; i++) {
    var old = pending[i];
    if (!old.parentNode) continue;

    var fresh = document.createElement('script');
    for (var j = 0; j < old.attributes.length; j++) {
      var attr = old.attributes[j];
      if (attr.name !== 'type') fresh.setAttribute(attr.name, attr.value);
    }
    fresh.text = old.textContent;

    // replaceChild senkron calistirir; blok icinde hata olsa bile
    // dongü durmaz (script hatalari cagirana firlatilmaz).
    old.parentNode.replaceChild(fresh, old);
  }
})();
